export const GLOBAL_STATE = 'Vacation'

export const VACATION_REQUEST_LIST = 'VACATION_REQUEST_LIST'
export const VACATION_REQUEST_CREATE = 'VACATION_REQUEST_CREATE'
export const VACATION_REQUEST_DELETE = 'VACATION_REQUEST_DELETE'
export const VACATION_REQUEST_DOWNLOAD = 'VACATION_REQUEST_DOWNLOAD'
export const VACATION_REQUEST_STATUS = 'VACATION_REQUEST_STATUS'
export const VACATION_PUBLIC_INFO = 'VACATION_PUBLIC_INFO'
